/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains products offered as cake fillings
 */
export const cakeFillingsContextKey = "cakeFillings";
